import {useContext} from "react";

import {SocialProofContext} from "./SocialProofContext";
import {SocialProofContextType} from "./interfaces";

export default function useSocialProofDetails(): SocialProofContextType {
  return useContext(SocialProofContext);
}
